export default function ({ products, isProductView, isCarousel = false }) {
    return {
        storeCode: window.alpineJs.storeCode || 'cz',
        discountType: window.alpineJs.discountType || 'percent',
        currency: window.alpineJs.currency || '',
        textSaveAmount: window.alpineJs.translate.saveAmount || '',
        productsList: [],
        loadingData: true,
        init() {
            this.getProductInfo();
            this.discountCatalogPrice(this.getPriceWrapper());
        },
        getPriceWrapper() {
            if (isProductView) {
                return '.product-info-price';
            }

            return '#product-price-wrapper';
        },
        discountCatalogPrice(wrapper) {
            const productPriceWrappers = this.$el.querySelectorAll(wrapper);

            productPriceWrappers.forEach((item) => {
                this.renderCatalogPriceDiscount(item);
            });
        },
        getProductPrice(productPriceWrapper) {
            const productPrice = productPriceWrapper.querySelector(
                '[data-price-type="finalPrice"]'
            );

            const productCatalogPrice = productPriceWrapper.querySelector(
                '[data-price-type="catalogPrice"]'
            );

            if (productPrice && productCatalogPrice) {
                const catalogPrice = productCatalogPrice
                    ? productCatalogPrice.getAttribute('data-price-amount')
                    : 0;

                return {
                    price: Number(
                        productPrice.getAttribute('data-price-amount')
                    ),
                    catalogPrice: Number(catalogPrice)
                };
            }

            return {
                price: Number(productPrice.getAttribute('data-price-amount')),
                catalogPrice: 0
            };
        },
        getProductInfo() {
            try {
                fetch(
                    `${window.BASE_URL}catalog_ajax_data/index/get?productIds=${products}&isProductView=${isProductView}`,
                    {
                        method: 'GET',
                        cache: 'no-store'
                    }
                )
                    .then((response) => response.json())
                    .then((data) => {
                        if (data) {
                            this.productsList = data;

                            if (isProductView) {
                                this.setProductLowestPrice(
                                    this.$refs.productWrapper
                                );
                            }

                            if (isCarousel) {
                                this.setProductProductFlagInCarousel();
                            }
                        }
                    })
                    .finally(() => {
                        this.loadingData = false;
                    });
            } catch (error) {
                this.loadingData = false;
                console.error(error);
            }
        },
        renderCatalogPriceDiscount(productWrapper) {
            const catalogPriceWrapper = productWrapper.querySelector(
                '.product__price--catalog > .price-container'
            );

            const price = this.getProductPrice(productWrapper);

            if (price.catalogPrice > price.price) {
                switch (this.discountType) {
                    case 'percent': {
                        const percent = this.calculateDiscountPercentage(
                            price.catalogPrice,
                            price.price
                        );
                        catalogPriceWrapper.classList.add(this.discountType);
                        catalogPriceWrapper.insertAdjacentHTML(
                            'beforeend',
                            this.percentHTML(percent)
                        );
                        break;
                    }
                    case 'amount': {
                        const amount = this.calculateAmountDiscount(
                            price.catalogPrice,
                            price.price
                        );
                        catalogPriceWrapper.classList.add(this.discountType);
                        catalogPriceWrapper.insertAdjacentHTML(
                            'beforeend',
                            this.amountHTML(amount)
                        );
                        break;
                    }
                    default:
                        break;
                }
            }
        },
        setProductLowestPrice(productWrapper) {
            const price = this.getProductPrice(productWrapper);
            const productLowestPrice =
                productWrapper.querySelector('.lowest-price');

            if (productLowestPrice) {
                const productId = Number(
                    productLowestPrice.getAttribute('data-product-id')
                );
                const productInformation =
                    this.getProductLowestPrice(productId);

                if (
                    productInformation &&
                    price.price < productInformation.price
                ) {
                    const percent = this.calculateDiscountPercentage(
                        productInformation.price,
                        price.price
                    );
                    productLowestPrice.innerHTML = `<div class="lowest-price__text">${
                        productInformation.message
                    }${
                        this.discountType === 'percent'
                            ? this.percentHTML(percent)
                            : ''
                    }</div>`;
                } else {
                    if (productInformation && productInformation.message) {
                        productLowestPrice.innerHTML = `<div class="lowest-price__text">${productInformation.message}</div>`;
                    }
                }
            }
        },
        setProductProductFlagInCarousel() {
            const productCarousel = this.$refs.productCarousel;

            if (productCarousel) {
                const productFlags = productCarousel.querySelectorAll(
                    '.product-item__flag'
                );

                productFlags.forEach((productFlag) => {
                    const productId = Number(
                        productFlag.getAttribute('data-product-id')
                    );
                    const productInformation = this.getProductFlag(productId);

                    if (productInformation) {
                        let htmlContent = '';
                        productInformation.forEach((flag) => {
                            const cssClass = flag.options.class
                                ? flag.options.class.join(' ')
                                : '';
                            const cssRedirect = flag.options.link_url
                                ? 'redirect'
                                : '';
                            const redirectUrl = flag.options.link_url
                                ? `onClick="window.location.href='${flag.options.link_url}'"`
                                : '';

                            htmlContent += `<span class="${cssClass} ${cssRedirect}" style="${flag.options.style}" ${redirectUrl}>${flag.options.label}</span>`;
                        });
                        productFlag.innerHTML = htmlContent;
                    }
                });
            }
        },
        getProductLowestPrice(productId) {
            const productInfo = JSON.stringify(this.productsList[productId]);
            if (productInfo) {
                const message =
                    JSON.parse(productInfo).lowest_price.frontend_value;
                const lowestPrice = JSON.parse(productInfo).lowest_price.price;

                if (!lowestPrice) {
                    return null;
                }

                return { message, price: lowestPrice };
            }
        },
        getDeliveryInfoRenderHtml(
            defaultDeliveryText,
            defaultDeliveryPrice,
            FreeShippingText,
            productId
        ) {
            const productInfo = JSON.stringify(this.productsList[productId]);

            if (productInfo) {
                const productDeliveryInfo = JSON.parse(productInfo).flag || {};

                if (Object.keys(productDeliveryInfo).length === 0) {
                    return defaultDeliveryText.replace(
                        '%1',
                        defaultDeliveryPrice
                    );
                }

                const findFreeDelivery = productDeliveryInfo.find(
                    (delivery) =>
                        delivery?.promotion?.free_delivery?.is_free_delivery ===
                        true
                );

                if (productDeliveryInfo.length > 1) {
                    if (findFreeDelivery) {
                        const delivery =
                            findFreeDelivery.promotion.free_delivery;
                        if (delivery.show_free_delivery_terms) {
                            return delivery.free_delivery_terms;
                        } else {
                            return `<span>${FreeShippingText}</span>`;
                        }
                    }

                    return defaultDeliveryText.replace(
                        '%1',
                        defaultDeliveryPrice
                    );
                }

                const freeDelivery =
                    productDeliveryInfo[0]?.promotion?.free_delivery
                        .is_free_delivery;
                const deliveryTerms =
                    productDeliveryInfo[0]?.promotion?.free_delivery
                        .free_delivery_terms;
                const showDeliveryTerms =
                    productDeliveryInfo[0]?.promotion?.free_delivery
                        .show_free_delivery_terms;

                if (freeDelivery) {
                    if (showDeliveryTerms) {
                        return deliveryTerms;
                    }
                    return `<span>${FreeShippingText}</span>`;
                }

                return defaultDeliveryText.replace('%1', defaultDeliveryPrice);
            }
            return defaultDeliveryText.replace('%1', defaultDeliveryPrice);
        },
        getProductFlag(productId) {
            const productInfo = JSON.stringify(this.productsList[productId]);

            if (productInfo) {
                const productFlag = JSON.parse(productInfo).flag || [];

                if (!productFlag) {
                    return [];
                }

                return productFlag;
            }
        },
        calculateAmountDiscount(originalPrice, discountedPrice) {
            if (originalPrice <= 0) {
                throw new Error('Original price must be greater than zero');
            }
            if (discountedPrice < 0) {
                throw new Error('Discounted price must be non-negative');
            }
            const discount = originalPrice - discountedPrice;

            if (this.storeCode === 'cz') {
                return Math.ceil(discount);
            }
            return discount.toFixed(2);
        },
        calculateDiscountPercentage(originalPrice, discountedPrice) {
            if (originalPrice <= 0) {
                throw new Error('Original price must be greater than zero');
            }
            if (discountedPrice < 0) {
                throw new Error('Discounted price must be non-negative');
            }
            const discount = originalPrice - discountedPrice;
            return Math.ceil((discount / originalPrice) * 100);
        },
        amountHTML(amount) {
            return `<span class="product__discount-amount">
                        <span>${this.textSaveAmount}</span>
                        <span>${amount} ${this.currency}</span>
                   </span>`;
        },
        percentHTML(percent) {
            return `<span class="product__discount-percent">-${percent}%</span>`;
        },
        productFlagClass(css, redirect) {
            const cssRedirect = redirect ? ' redirect' : '';
            return [`${css} ${cssRedirect}`];
        },
        redirectTo(e, linkUrl) {
            const clickedElement = e.target;

            if (
                clickedElement.classList.contains('product__promotion-info') ||
                (clickedElement.classList.contains('title') && linkUrl) ||
                (clickedElement.classList.contains('product-flag') && linkUrl)
            ) {
                window.location.href = linkUrl;
            }
        },
        redirectToProduct(url, onlyMobile) {
            const isMobile = window.innerWidth < 768;
            const mobileOnly = JSON.parse(onlyMobile);

            if (!mobileOnly || (mobileOnly && isMobile)) {
                window.location.href = url;
            }
        }
    };
}
